/**
 * @generated SignedSource<<21d3204ef9668dd72220ff9ac93db39f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NftPdpExhibitionNoteImageList_note$data = {
  readonly caption: string | null;
  readonly images: ReadonlyArray<{
    readonly height: number | null;
    readonly url: string | null;
    readonly width: number | null;
  } | null> | null;
  readonly " $fragmentType": "NftPdpExhibitionNoteImageList_note";
};
export type NftPdpExhibitionNoteImageList_note$key = {
  readonly " $data"?: NftPdpExhibitionNoteImageList_note$data;
  readonly " $fragmentSpreads": FragmentRefs<"NftPdpExhibitionNoteImageList_note">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NftPdpExhibitionNoteImageList_note",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "caption",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "NftExhibitionNoteImageListImage",
      "kind": "LinkedField",
      "name": "images",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "width",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "height",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "NftExhibitionNoteImageListContent",
  "abstractKey": null
};

(node as any).hash = "c632aeb95f0a74303deed715358e7b83";

export default node;
